
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuItem, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { Share, MessageCircle, Facebook, Instagram, Twitter } from 'lucide-react';
import { toast } from "sonner";

interface ShareButtonProps {
  vacation: any;
  className?: string;
}

export const ShareButton = ({ vacation, className = "" }: ShareButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const shareData = {
    title: `${vacation.name} - ${vacation.country}`,
    text: `Bekijk deze geweldige vakantie: ${vacation.name} in ${vacation.country}${vacation.price ? ` vanaf €${vacation.price}` : ''}`,
    url: vacation.productURL || window.location.href
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        toast.success("Vakantie gedeeld!");
      } catch (error) {
        // User cancelled or error occurred
      }
    } else {
      // Fallback to copying to clipboard
      await navigator.clipboard.writeText(`${shareData.text} - ${shareData.url}`);
      toast.success("Link gekopieerd naar klembord!");
    }
    setIsOpen(false);
  };

  const handleWhatsAppShare = () => {
    const text = encodeURIComponent(`${shareData.text} - ${shareData.url}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
    setIsOpen(false);
  };

  const handleFacebookShare = () => {
    const url = encodeURIComponent(shareData.url);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
    setIsOpen(false);
  };

  const handleTwitterShare = () => {
    const text = encodeURIComponent(shareData.text);
    const url = encodeURIComponent(shareData.url);
    window.open(`https://twitter.com/intent/tweet?text=${text}&url=${url}`, '_blank');
    setIsOpen(false);
  };

  const handleInstagramShare = () => {
    // Instagram doesn't support direct URL sharing, so we copy to clipboard
    navigator.clipboard.writeText(`${shareData.text} - ${shareData.url}`);
    toast.success("Link gekopieerd! Plak in je Instagram story of post.");
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="ghost" 
          size="sm" 
          className={`h-8 w-8 p-0 hover:bg-blue-50 ${className}`}
        >
          <Share className="h-4 w-4 text-gray-500 hover:text-blue-600" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={handleNativeShare} className="cursor-pointer">
          <Share className="h-4 w-4 mr-2" />
          Delen
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleWhatsAppShare} className="cursor-pointer">
          <MessageCircle className="h-4 w-4 mr-2 text-green-600" />
          WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleFacebookShare} className="cursor-pointer">
          <Facebook className="h-4 w-4 mr-2 text-blue-600" />
          Facebook
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleTwitterShare} className="cursor-pointer">
          <Twitter className="h-4 w-4 mr-2 text-blue-400" />
          Twitter
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleInstagramShare} className="cursor-pointer">
          <Instagram className="h-4 w-4 mr-2 text-pink-600" />
          Instagram
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
